import React, { useCallback, useRef } from "react";
import { StyleSheet } from "react-native";
import { typographyVariants } from "../components/Typography/variants";
import { palette, spacing } from "../styles";
import Inputs, { type OtpInputsRef } from "./lib";

type Props = {
  handleSubmit: (value: string) => void;
  onChange?: (value: string) => void;
  numberOfInputs: number;
  selfCenter?: boolean;
};

const OtpInput = ({ onChange, handleSubmit, numberOfInputs = 4, selfCenter = false }: Props) => {
  const otpInputsRef = useRef<OtpInputsRef>(null);
  const otpCalled = useRef(false);

  const handleChange = useCallback(
    (value: string) => {
      onChange?.(value);
      if (value?.length === numberOfInputs && !otpCalled.current) {
        otpCalled.current = true;
        handleSubmit(value);
        setTimeout(() => {
          otpCalled.current = false;
          otpInputsRef.current?.reset();
        }, 100);
      }
    },
    [handleSubmit, numberOfInputs, onChange],
  );

  return (
    <Inputs
      autoFocus
      autofillFromClipboard={false}
      handleChange={handleChange}
      inputContainerStyles={styles.inputContainer}
      inputStyles={styles.input}
      numberOfInputs={numberOfInputs}
      placeholder="-"
      ref={otpInputsRef}
      selectTextOnFocus={false}
      style={[styles.container, { alignSelf: selfCenter ? "center" : "flex-start" }]}
    />
  );
};

export default React.memo(OtpInput);

const styles = StyleSheet.create({
  container: {
    borderRadius: spacing.radius,
    borderWidth: spacing.border,
    flexDirection: "row",
    padding: spacing.unit / 4,
    flexWrap: "wrap",
  },
  input: {
    ...typographyVariants.input,
    backgroundColor: palette.common.white,
    height: spacing.unit * 6,
    textAlign: "center",
    width: spacing.unit * 6,
  },
  inputContainer: {
    borderColor: palette.font.placeholder,
  },
});
